import React from 'react'

import { Box, Typography } from '@material-ui/core'

import { DoneOutlined } from '@material-ui/icons'

const CardPaymentMethod = ({ title, description }) => {
  return (
    <Box display="flex" alignItems="flex-start">
      <Box mt={-1} mr={2} color="success.main">
        <DoneOutlined fontSize="large" />
      </Box>

      <Box>
        <Box mb={1 / 2}>
          <Typography variant="h5" color="textSecondary">
            {title}
          </Typography>
        </Box>
        <Typography color="textSecondary">{description}</Typography>
      </Box>
    </Box>
  )
}

export default CardPaymentMethod
